export const SECTIONS = [
  { id: 1, title: 'Why This Matters' },
  { id: 2, title: 'The Setup' },
  { id: 3, title: 'HTML: Text & Structure' },
  { id: 4, title: 'HTML: Links & Media' },
  { id: 5, title: 'HTML: Lists & Tables' },
  { id: 6, title: 'HTML: Grouping & Semantic Tags' },
  { id: 7, title: 'How CSS Actually Works' },
  { id: 8, title: 'Selectors Deep Dive' },
  { id: 9, title: 'Colors, Backgrounds & Units' },
  { id: 10, title: 'Typography' },
  { id: 11, title: 'The Box Model' },
  { id: 12, title: 'Display & Positioning' },
  { id: 13, title: 'CSS Variables & Transitions' },
  { id: 14, title: 'Flexbox' },
  { id: 15, title: 'Responsive Design' },
  { id: 16, title: 'Final Project' },
];
